ui-download-search-sort {
  .search-sort {
    &__wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 46px;
      margin-top: 46px;
    }

    &__filter {
      width: 25%;
      margin-left: 12px;
    }

    &__button {
      margin-top: 16px;
      width: 100%;
    }

    ui-cms-offcanvas-panel {
      width: 100%;
      display: flex;
    }

    &-panel {
      &__headline {
        color: $ui-blue;
      }

      &__wrapper {
        height: 100%;
        padding: 10px 28px 40px;
        background-color: var(--skin-color-secondary-lighter, $ui-grey-minus-3);
      }

      &__link {
        margin-top: 19px;
        margin-bottom: 23px;
      }

      &__radio {
        margin-top: 12px;
      }

      &__button {
        margin-top: 15px;
      }
    }
  }
}
